module.exports = __webpack_public_path__ + "static/media/builtinv2-шины.d67878db.png";